<template>
  <div class="col-12 register-page py-3 py-lg-5">
    <div class="col-12 register-block px-0 px-lg-2">
      <div class="row mx-0 col-12 col-sm-8 col-lg-7 mx-auto px-0 register-form-area py-3 pb-5 page-dark-bg px-0 px-lg-2">
        <h4 class="w-100 text-center mt-3 mb-5 my-lg-5 page-main-title text-white">
          Заполните форму регистрации
        </h4>
        <b-form
          class="registration-form row mx-0 justify-content-between"
          autocomplete="off" @submit.prevent="Registration">
          <div class="col-12 col-lg-6 px-0 justify-content-center">
            <div class="col-12">
              <div class="input-group mb-4">
                <div class="col-12">
                  <input
                    v-model="payload.user_login"
                    class="form-control auth-input"
                    required
                    type="text"
                    placeholder="Логин *"
                  >
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="input-group mb-4">
                <div class="col-12">
                  <input
                      v-model="payload.user_password"
                      type="password"
                      class="form-control auth-input"
                      required
                      placeholder="Пароль *"
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-6 px-0 justify-content-center">
            <div class="col-12">
              <div class="input-group mb-4">
                <div class="col-12">
                  <input
                      v-model="payload.user_email"
                      class="form-control auth-input"
                      type="email"
                      placeholder="Емайл *"
                      required
                  >
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="input-group mb-4">
                <div class="col-12">
                  <input
                      v-model="payload.user_phone"
                      v-mask="getSelectedMethodMask"
                      class="form-control auth-input"
                      placeholder="Номер телефона *"
                      required
                      type="text"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-12 px-0 justify-content-center">

            <div class="col-12 col-lg-6">
              <div class="input-group mb-4">
                <div class="col-12">
                  <label class="col-form-label mr-3 text-white">У вас есть промокод?</label>
                  <input type="checkbox" v-model="payload.promo_exist" @change="unsetParams">
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-6" v-if="payload.promo_exist">
              <div class="input-group mb-4">
                <div class="col-12">
                  <input
                      v-model="payload.promo_code"
                      type="text"
                      class="form-control auth-input"
                      placeholder="Промокод"
                  >
                  <small class="form-text text-muted">Если нет промокода, оставьте поле пустым</small>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 px-0 row mx-0 justify-content-center" v-if="!enabledRegistration && !payload.promo_exist"  id="users_referer_area">
            <div class="col-12 col-lg-6">
              <div class="input-group mb-4">
                <div class="col-12">
                  <input
                      v-model="payload.referer_login"
                      class="form-control auth-input"
                      required
                      type="text"
                      placeholder="Логин друга *"
                  >
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="input-group mb-4">
                <div class="col-12">
                  <input
                      v-model="payload.contact_info"
                      type="password"
                      class="form-control auth-input"
                      required
                      placeholder="Ваша контактная информация для связи *"
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="col-12">
              <small class="form-text text-muted my-2">
                <i class="fa fa-info-circle"></i>
                Поля помеченные * обязательны к заполнению
              </small>
            </div>
          </div>
          <div class="col-12 agree-terms-area">
            <div class="col-12">
              <small class="form-text text-muted my-2">
                <input
                  v-model="payload.confirm_terms"
                  type="checkbox"
                  class="reg-agree-terms"
                  required="required"
                >
                Я согласен с правилами и условиями и защитой информации
                <button name="submit" v-b-modal.agreeTermsModal class="bg-transparent border-0 text-muted">
                  <i class="fa fa-info-circle"></i>
                </button>
              </small>
            </div>
          </div>
          <div class="col-12">

            <div class="col-12" v-if="getAdminTgLinks">
            <span class="text-white"> В случае возникновения вопросов, пожалуйста, обращайтесь в
              <a target="_blank" :href="getAdminTgLinks">администрацию сайта через Telegram.</a></span>
            </div>

            <div class="col-12 col-lg-8 mx-auto my-3">
              <alert :message="response"></alert>
              <div class="clearfix"></div>
            </div>

            <div class="col-12 mt-3 mx-0">
              <div class="col-12 col-md-6 col-lg-5 col-xl-4 mx-auto px-0">
                <div class="">
                  <button
                    name="submit"
                    class="btn auth-btn main-btn w-100"
                    :disabled="isSubmitting"
                    @click.prevent="Registration">
                    Зарегистрироваться
                  </button>
                </div>
              </div>
            </div>
          </div>
        </b-form>
      </div>
    </div>

    <b-modal
      id="agreeTermsModal"
      title="Условия и соглашения"
      size="xl"
      modal-class="main-modal register-terms-modal"
      ok-title="Закрыть"
      ok-only
      ok-variant="success modal-ok"
      header-class="text-white border-0"
      header-close-variant="white"
      footer-class="border-0"
    >
      <Terms></Terms>
    </b-modal>
  </div>
</template>

<script>
import Alert from '@/components/Alert'
import Terms from './RegisterTerms'

export default {
  name: 'Register',
  data () {
    return {
      response: null,
      isSubmitting: false,
      payload: {
        user_login: '',
        user_email: '',
        user_password: '',
        user_phone: '',
        promo_code: '',
        user_currency: 1,
        confirm_terms: false,
        referer_login: '',
        contact_info: '',
        promo_exist: true,
      },
      acceptedPhones: {
        ru: {
          code: '+7',
          flag: 'b'
        },
        ukr: {
          code: '+38',
          flag: 'a'
        }

      }
    }
  },
  components: {
    Alert,
    Terms
  },
  methods: {
    Registration () {
      this.response = { status: 'loading' }
      this.isSubmitting = true
      const login = this.payload.user_login
      const email = this.payload.user_email
      const password = this.payload.user_password
      const user_phone = this.payload.user_phone
      const confirmedTerms = this.payload.confirm_terms

      if (login === '' || email === '' || user_phone === '' || password === '') {
        this.isSubmitting = false
        this.response = { status: 'error', msg: 'Заполните все необходимые поля' }
        return
      }

      if (!confirmedTerms) {
        this.isSubmitting = false
        this.response = { status: 'error', msg: 'Вы должны согласиться с правилами и условиями' }
        return
      }
      let sendData  = this.payload
      if(!this.payload.promo_exist){
        delete sendData.promo_exist
      }
      this.axios.post(
        this.$_config.baseUrl + '/Api/registration',
        sendData, {
          withCredentials: true
        }
      ).then(({ data }) => {
        this.isSubmitting = false
        this.response = data
        if (data.status === 'ok') {
          this.$store.dispatch('fetchUserData')
          this.$store.dispatch("getMainSettings")
          this.$store.dispatch("fetchApiData")

          setTimeout(() => {
            if (!this.userData) {
              return this.$router.push({name: 'home'})
            }
          }, 5000)
        }
      }).catch((err) => {
        if (err) {
          this.isSubmitting = false
          this.response = { status: 'error', msg: "Что-то пошло не так." }
        }
      })
    },
    unsetParams() {
      this.payload.promo_code = "";
      this.payload.referer_login = "";
      this.payload.contact_info = "";
    }
  },
  computed: {
    isAuthorized () {
      return this.$store.getters.userData
    },
    getSelectedMethodMask () {
      let masks = ["+#(###)###-##-##","+##(###)###-##-##"];
      return typeof masks === 'string' ? masks :masks.join(',').split(',')
    },
    enabledRegistration(){
      return this.$store.getters.getEnabledRegistration
    },
    getAdminTgLinks() {
      return this.$store.getters.getSocialLinks['site_administration']
    }
  },
  watch: {
    isAuthorized (newValue) {
      if (newValue) {
        this.$router.push({ name: 'home' })
      }
    }
  },
  mounted () {
    this.$root.$emit('bv::hide::modal', 'loginModal')
    if (this.isAuthorized) {
      this.$router.push({ name: 'home' })
    }
  }
}
</script>
